function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnalytics(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.5,
    height: 15.5,
    viewBox: "0 0 15.5 15.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9991",
    d: "M1018.161 177.883a8.023 8.023 0 0 0-1.143-2.336l-.007-.012-.011-.012a8.095 8.095 0 0 0-.453-.581 8.124 8.124 0 0 0-6.174-2.839.3.3 0 0 0-.3.3v.972a6.867 6.867 0 1 0 7.161 7.159h.972a.3.3 0 0 0 .3-.3 8.145 8.145 0 0 0-.345-2.351zm-.26 2.051h-5.407a2.118 2.118 0 0 0-.2-.643l4.4-3.157a7.423 7.423 0 0 1 .9 1.922 7.541 7.541 0 0 1 .306 1.878zm-7.526-1.242a1.542 1.542 0 1 1-1.542 1.542 1.544 1.544 0 0 1 1.542-1.541zm5.718-3.36q.131.153.253.311l-4.389 3.152a2.136 2.136 0 0 0-1.282-.679v-5.405a7.523 7.523 0 0 1 5.417 2.622zm-5.719 11.17a6.268 6.268 0 0 1-.3-12.528v4.141a2.141 2.141 0 1 0 2.42 2.418h4.141a6.276 6.276 0 0 1-6.261 5.967z",
    transform: "translate(-1003.257 -171.853)",
    style: {
      fill: "currentColor",
      stroke: "currentColor",
      strokeWidth: ".5px"
    },
    id: "analyticsIcon"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.029038a5.svg";
export { ForwardRef as ReactComponent };